/** store */
import CmsStore from "redbay-b2b-cms/src/CmsStore";
import BannerStore from "redbay-b2b-banners/src/BannerStore";
import { UserStore, AUTHORIZED_USER } from "./user/src/UserStore";
import CompanyStore from "./company/src/CompanyStore";
import CategoriesStore from "redbay-b2b-categories/src/CategoriesStore";
import SearchStore from "./products/src/search/SearchStore";
import BrandStore from "redbay-b2b-brands/src/BrandStore";
import BasketStore from "redbay-b2b-basket/src/BasketStore";
import OrderStore from "redbay-b2b-order/src/OrderStore";
import OfferStore from "redbay-b2b-offer/src/OfferStore";

export function Store() {
  return {
    banner: BannerStore,
    cms: CmsStore,
    user: UserStore,
    company: CompanyStore,
    categories: CategoriesStore,
    search: SearchStore,
    basket: BasketStore,
    brands: BrandStore,
    order: OrderStore,
    offer: OfferStore
  };
}

/** router */

import UserRouter from "./user/src/Router";
import CompanyRouter from "./company/src/Router";
import AccountRouter from "./account/src/account/Router";
import PageRouter from "redbay-b2b-cms/src/Router";
import BasketRouter from "redbay-b2b-basket/src/Router";
import OrderRouter from "redbay-b2b-order/src/Router";
import OfferRouter from "redbay-b2b-offer/src/Router";

export function ComponentsRouter() {
  return [
    ...UserRouter.routers(),
    ...AccountRouter.routers(),
    ...PageRouter.routers(),
    ...BasketRouter.routers(),
    ...CompanyRouter.routers(),
    ...OrderRouter.routers(),
    ...OfferRouter.routers()
  ];
}

export let USER_AUTHORIZED_USER = AUTHORIZED_USER;

export { default as ApiClient } from "redbay-b2b-api/src/ApiClient";

export { default as SingInPage } from "./user/src/SignPage.vue";
export { default as Cms } from "redbay-b2b-cms/src/Cms";
export { default as Page } from "redbay-b2b-cms/src/Page.vue";

export { default as BannerOpacity } from "redbay-b2b-banners/src/BannerOpacity.vue";

export { default as ContactForm } from "./company/src/ContactForm.vue";



// WEBPACK FOOTER //
// ./src/components/RedbayComponents.js